import React from "react";

const GeneralException = ({ error }) => {
    const message = error.statusText || error.message;

    return (
        <>
            <h1>Oops! Something went wrong</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>Description: {message}</p>
        </>
    );
};

export default GeneralException;
